import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { LanguageFormValues } from "src/models/Language.model";

type Props = {
  formikProps: FormikProps<LanguageFormValues>;
  onClose: () => void;
  formType?: "ADD" | "EDIT";
};

const LanguageForm = ({ formType, formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "EDIT" ? "Update Language" : "Add Language"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="languageName"
            placeholder="Enter language"
            value={values.languageName}
            label="Language"
            onBlur={handleBlur}
            onChange={(e) => {
              setFieldValue("languageName", e.target.value);
            }}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default LanguageForm;
